import React from 'react';

function Overlay({ size, stroke, strokeWidth, ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      {...otherProps}
    >
      <rect
        x="3.65"
        y="3.65"
        width="12.7"
        height="12.7"
        rx="1.35"
        stroke={stroke}
        strokeWidth={strokeWidth}
      />
      <rect
        x="7.65"
        y="7.65"
        width="12.7"
        height="12.7"
        rx="1.35"
        stroke={stroke}
        strokeWidth={strokeWidth}
      />
      <path d="M7.5 12.5L12.5 7.5" stroke={stroke} strokeWidth={strokeWidth} />
      <path d="M11.5 16.5L16.5 11.5" stroke={stroke} strokeWidth={strokeWidth} />
      <path d="M7.5 16.5L16.5 7.5" stroke={stroke} strokeWidth={strokeWidth} />
    </svg>
  );
}

export default Overlay;
